export enum InvoiceSendingTypeStringEnum {
  emailinvoice = 'emailinvoice',
  invoice = 'invoice',
  reminder1 = 'reminder1',
  reminder2 = 'reminder2',
  card = 'card',
  emailreminder = 'emailreminder',
  sms = 'sms',
  smsreminder = 'smsreminder',
}

export const getSendingSessionTypeText = (type: InvoiceSendingTypeStringEnum, t: (n: string) => string): string => {
  return t(`invoice:invoiceSendingTypeStringText.${type}`) || t('invoice:invoiceSendingTypeStringText.unknown');
};
